(function () {
  const widget = document.getElementById('fpv-widget');
  const modal = document.getElementById('fpv-modal');
  const modalVideo = document.getElementById('fpv-modal-video');

  if (!widget) return;

  const productId = widget.dataset.productId;

  // ── Delay + Show ──
  const delay = parseInt(widget.dataset.delay || '0', 10) * 1000;
  setTimeout(() => {
    if (window._fpvClosed) return;
    widget.classList.add('fpv-visible');
  }, delay);

  // ── Close ──
  const closeBtn = widget.querySelector('.fpv-close');
  if (closeBtn) {
    closeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      window._fpvClosed = true;
      widget.style.display = 'none';
    });
  }

  // ── Minimize / Restore ──
  const minimizeBtn = widget.querySelector('.fpv-minimize');
  const restoreBtn = widget.querySelector('.fpv-restore');

  if (minimizeBtn) {
    minimizeBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      widget.classList.add('fpv-minimized');
    });
  }

  if (restoreBtn) {
    restoreBtn.addEventListener('click', (e) => {
      e.stopPropagation();
      widget.classList.remove('fpv-minimized');
    });
  }

  // ── Open Modal ──
  const inner = widget.querySelector('.fpv-inner');
  if (inner && modal) {
    inner.addEventListener('click', () => {
      modal.classList.add('fpv-modal-open');
      if (modalVideo) {
        modalVideo.currentTime = 0;
        modalVideo.muted = false;
        modalVideo.play();
      }
    });
  }

  // ── Close Modal ──
  const modalClose = modal ? modal.querySelector('.fpv-modal-close') : null;
  const modalBackdrop = modal ? modal.querySelector('.fpv-modal-backdrop') : null;

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('fpv-modal-open');
    if (modalVideo) {
      modalVideo.pause();
      modalVideo.muted = true;
    }
  }

  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modalBackdrop) modalBackdrop.addEventListener('click', closeModal);

  // ── Drag ──
  let dragging = false;
  let startX, startY, startLeft, startBottom;

  widget.addEventListener('mousedown', dragStart);
  widget.addEventListener('touchstart', dragStart, { passive: true });

  function dragStart(e) {
    if (e.target.classList.contains('fpv-btn')) return;
    if (e.target.classList.contains('fpv-restore')) return;
    dragging = true;
    widget.classList.add('fpv-dragging');

    const touch = e.touches ? e.touches[0] : e;
    startX = touch.clientX;
    startY = touch.clientY;

    const rect = widget.getBoundingClientRect();
    startLeft = rect.left;
    startBottom = window.innerHeight - rect.bottom;

    document.addEventListener('mousemove', dragMove);
    document.addEventListener('touchmove', dragMove, { passive: false });
    document.addEventListener('mouseup', dragEnd);
    document.addEventListener('touchend', dragEnd);
  }

  function dragMove(e) {
    if (!dragging) return;
    if (e.cancelable) e.preventDefault();

    const touch = e.touches ? e.touches[0] : e;
    const dx = touch.clientX - startX;
    const dy = touch.clientY - startY;

    let newLeft = startLeft + dx;
    let newBottom = startBottom - dy;

    newLeft = Math.max(0, Math.min(newLeft, window.innerWidth - widget.offsetWidth));
    newBottom = Math.max(0, Math.min(newBottom, window.innerHeight - widget.offsetHeight));

    widget.style.left = newLeft + 'px';
    widget.style.right = 'auto';
    widget.style.bottom = newBottom + 'px';
    widget.style.top = 'auto';
  }

  function dragEnd() {
    if (!dragging) return;
    dragging = false;
    widget.classList.remove('fpv-dragging');

    document.removeEventListener('mousemove', dragMove);
    document.removeEventListener('touchmove', dragMove);
    document.removeEventListener('mouseup', dragEnd);
    document.removeEventListener('touchend', dragEnd);

    const rect = widget.getBoundingClientRect();
    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;
    const snapRight = centerX > window.innerWidth / 2;
    const snapBottom = centerY > window.innerHeight / 2;

    const side = parseInt(widget.style.getPropertyValue('--fpv-side') || '20', 10);
    const bottom = parseInt(widget.style.getPropertyValue('--fpv-bottom') || '20', 10);

    widget.style.left = snapRight ? 'auto' : side + 'px';
    widget.style.right = snapRight ? side + 'px' : 'auto';
    widget.style.top = snapBottom ? 'auto' : side + 'px';
    widget.style.bottom = snapBottom ? bottom + 'px' : 'auto';

    widget.classList.remove('fpv-dragging');
    widget.style.transition = 'left 0.3s, right 0.3s, top 0.3s, bottom 0.3s, opacity 0.4s';
    setTimeout(() => {
      widget.style.transition = '';
    }, 300);
  }

})();